<template>
  <div class="city-lawyer-post-select">
    <CityLawyerPostSelect
      :type="type"
      :label="label"
      :icon="icon"
      @on-select="selectPost"
    />
  </div>
</template>

<script>
import CityLawyerPostSelect from 'Components/CityLawyerPostSelect.vue';

export default {
  name: 'CityLawyerSelectContainer',

  components: {
    CityLawyerPostSelect,
  },

  data() {
    return {
      type: this.$mountEl.dataset.type ? this.$mountEl.dataset.type : '',
      label: this.$mountEl.dataset.label ? this.$mountEl.dataset.label : '',
      icon: this.$mountEl.dataset.icon ? this.$mountEl.dataset.icon : '',
    };
  },

  methods: {
    selectPost(value) {
      if (!value) {
        return;
      }

      window.location = value.choice;
    },
  },
};
</script>
